export default __webpack_public_path__ + "static/media/icon-avatar.14b4a5fb.svg";